module.exports = __webpack_public_path__ + "img/stand.2ab4276e.png";